











import { defineComponent } from '@nuxtjs/composition-api';
import { useStore } from '@/compositions/store';
import NewsDetail from '@/components/news-detail.vue';
import ApplicationBar from '@/components/layout/applicationbar.vue';

export default defineComponent({
  components: { ApplicationBar, NewsDetail },
  layout: 'plain',
  setup() {
    // パンくず設定
    const { setBreadcrumb } = useStore();
    setBreadcrumb('/news');
  }
});
